import React from 'react'
import Category from './category/Category'
import Trending from './trending/Trending'
// import useStyles from './styles'

const CategorySection = () => {
	// const classes = useStyles()
	return (
		<>
			<Category />
			<Trending />
		</>
	)
}

export default CategorySection
